import { z } from "zod"
import { Session, Sessions, SignedIn, SignedOut } from "accounts/domain/session"

const userSchema = z.object({
  isAnonymous: z.boolean(),
  isGuest: z.boolean().default(false)
})

type User = z.infer<typeof userSchema>

const sessionOf = (user: User): Session => {
  if (user.isAnonymous || user.isGuest) {
    return new SignedOut()
  } else {
    return new SignedIn()
  }
}

export class ApiSessions implements Sessions {
  current = async (): Promise<Session> => {
    const response = await window.fetch(`/api/v1/accounts/user/`, {
      method: `GET`,
      credentials: `same-origin`
    })

    if (response.ok) {
      return sessionOf(userSchema.parse(await response.json()))
    } else {
      throw new Error(`Session unavailable: ${response.status}`)
    }
  }
}
